import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Container, Grid, Hidden, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import Bottom from "./Bottom";
import useEncyclopediaStore from "../store/encyclopediaStore";
import { useEffect } from "react";
import api from "../utils/api_v2";
import LodingData from "../utils/LodingData";

import "../components/common/PaginationComponent.css";
import tabbg from "../assets/images/tab_03.png"
import { useLocation, useNavigate } from "react-router-dom";


const EncyclopediaDetail = () => {

  const storeData: any = useEncyclopediaStore();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getEncyclopediaDetail();

    return () => {
      storeData.detailClear();
    }
  }, [])

  function getEncyclopediaDetail() {
    LodingData(() => api.post('customer/api/v1/CU0902', { id: location.state })
      .then(res => {
        console.log(res);
        storeData.setContentsInfo(res.data);
      })
      .catch(err => {
        console.log(err);
      }));
  }


  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#b2f7ab', fontWeight: 900, }}>
              건강정보
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ee725', fontWeight: 500, }} gutterBottom>
              질병백과
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <TableContainer sx={{ background: '#fff', p: 5, width: '80%', borderRadius: 3, mt: 2 , ml:'auto', mr:'auto'}}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>

                <Box className="talign_center" sx={{ width: '100%', margin: '0 auto'}}>
                  {
                    storeData.contentsInfo.fileName && storeData.contentsInfo.fileName.includes('s3')
                      ? <img
                        style={{ width: '100%' }}
                        src={storeData.contentsInfo.fileName + '?origin=' + storeData.contentsInfo.originalFileName}
                        alt={storeData.contentsInfo.fileName}
                      />
                      : <img
                        style={{ width: '100%' }}
                        src={'https://file.dualhealth.kr/healthContent/images/' + storeData.contentsInfo.fileName + '?origin=' + storeData.contentsInfo.originalFileName}
                        alt={storeData.contentsInfo.fileName}
                      />

                  }
                </Box>
                <Typography variant="h5" mt={4}>{storeData.contentsInfo.title}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight" sx={{width: '100%'}}><span className="t-color">01</span> 정의</Typography>
                <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap' }}>{storeData.contentsInfo.content1}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight" sx={{width: '100%'}}><span className="t-color">02</span> 진단방법</Typography>
                <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap' }}>{storeData.contentsInfo.content2}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight" sx={{width: '100%'}}><span className="t-color">03</span> 원인</Typography>
                <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap' }}>{storeData.contentsInfo.content3}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight" sx={{width: '100%'}}><span className="t-color">04</span> 증상</Typography>
                <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap' }}>{storeData.contentsInfo.content4}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight" sx={{width: '100%'}}><span className="t-color">05</span> 치료법</Typography>
                <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap' }}>{storeData.contentsInfo.content5}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight" sx={{width: '100%'}}><span className="t-color">06</span> 식이방법</Typography>
                <Table className="Cl_table cursor_default" size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: '#e6e6e6!important', textAlign: 'center', width: '80px' }}>권장</TableCell>
                      <TableCell sx={{width: '40%'}}>
                        <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap', textAlign: 'left', paddingLeft: '10px'}}>{storeData.contentsInfo.content61}</Typography>
                      </TableCell>
                      <TableCell sx={{ backgroundColor: '#e6e6e6', textAlign: 'center', width: '80px' }}>주의</TableCell>
                      <TableCell sx={{width: '40%'}}>
                        <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap', textAlign: 'left', paddingLeft: '10px'}}>{storeData.contentsInfo.content62}</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="h6" mb={1} className="font_weight"><span className="t-color">07</span> 운동방법</Typography>
                <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-wrap' }}>{storeData.contentsInfo.content7}</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box className='talign_left' sx={{ margin: '20px 0px' , ml: 15 }}>
        <Button className="btn_list" onClick={() => navigate(-1)}>목록</Button>
      </Box>

      <Bottom />
    </Container>
  )
}
const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default EncyclopediaDetail;